module.exports = "/_next/static/images/tagname-e2b4649d7451cf3a091bda8294054615.png";